import React from 'react';
import { useTranslation } from 'react-i18next';
import { Theme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { Grid, KeyValue, Link, Pill, SectionHeader } from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { stringToLongDateAndShortTime } from '../../../utils/DateUtils';
import { AccessArrangmentGetSummaryDetails } from '../../../api/candidate/access-arrangement/model';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  applicationDetailsContainer: {
    marginBottom: theme.spacing(3),
  },
  downloadPdf: {
    display: 'flex',
    marginTop: theme.spacing(1.3),
    paddingLeft: theme.spacing(3),
  },
  keyValueContainer: {
    marginTop: theme.spacing(2),
  },
}));

interface IApplicationDetails {
  handleDownloadPdf: () => void;
  data: AccessArrangmentGetSummaryDetails;
}

const ApplicationDetails = ({ handleDownloadPdf, data }: IApplicationDetails) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const generateStatusPill = (status: string) => {
    /** request Vincent Marcos to take a look at this
     * why using switch statement here and not using
     * the status param
     * */
    switch (status) {
      default:
        return (
          <Grid>
            <Pill label="Submitted" variant="info" />
          </Grid>
        );
    }
  };

  const role = window.location.pathname.includes('coordinator') ? 'coordinator' : 'candidate';
  return (
    <Grid className={classes.applicationDetailsContainer}>
      <Grid container direction="row" alignItems="flex-start">
        <Grid md={4} sm={6} xs={6}>
          <SectionHeader title={t('accessArrangement->>Summary.SectionHeader')} />
        </Grid>
        <Grid md={8} sm={6} xs={6}>
          <Link
            className={classes.downloadPdf}
            id="link-download"
            onClick={() => handleDownloadPdf()}
          >
            <IconWithLabel
              iconName={IconName.download}
              iconSize="M"
              label={t('exam->>RegistrationSummary.DownloadSummary')}
              typographyProps={{
                variant: 'h5',
              }}
            />
          </Link>
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid md={6} sm={12} xs={12} className={classes.keyValueContainer}>
          <KeyValue
            id="candidateName"
            keyText={t('accessArrangement->>Summary.ApplicationID')}
            valueText={data.accessArrangementSubmittedDataModel.applicationId}
          />
        </Grid>
        <Grid md={6} sm={12} xs={12} className={classes.keyValueContainer}>
          <KeyValue
            id="candidateName"
            keyText={t('accessArrangement->>Summary.Status')}
            valueText={generateStatusPill(data.accessArrangementSubmittedDataModel?.requestStatus)}
          />
        </Grid>
      </Grid>
      <Grid xs={12} className={classes.keyValueContainer}>
        <KeyValue
          id="candidateName"
          keyText={t('accessArrangement->>Summary.ApplicationDateTime')}
          valueText={stringToLongDateAndShortTime(
            data.accessArrangementSubmittedDataModel.applicationDateTime
          )}
        />
      </Grid>
      {data.accessArrangementRequestReviewModel.coordinatorName && role === 'coordinator' && (
        <Grid xs={12} className={classes.keyValueContainer}>
          <KeyValue
            id="coordinateName"
            keyText={t('accessArrangement->>Summary.CoordinatorName')}
            valueText={data.accessArrangementRequestReviewModel.coordinatorName}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default ApplicationDetails;
